class ProductCardSwatches extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (e) => {
      if (!e.target.closest("[data-more-trigger]")) return;

      this._showAll();
    });

    this.addEventListener("change", (e) => {
      this._swatchChanged();

      if (!e.target.closest(".product-card__swatch-wrapper--hidden")) return;

      this._showAll();
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}

  _swatchChanged() {
    document.dispatchEvent(new CustomEvent("swatch:changed"));
  }

  _showAll() {
    if (this.showedAll) return;

    this.showedAll = true;

    const hiddenSwatches = this.querySelectorAll(
      ".product-card__swatch-wrapper--hidden",
    );

    hiddenSwatches.forEach((el) =>
      el.classList.remove("product-card__swatch-wrapper--hidden"),
    );

    if (hiddenSwatches[0]) {
      hiddenSwatches[0].querySelector("input").focus();
    }

    this.moreTrigger.remove();
  }

  get moreTrigger() {
    return this.querySelector("[data-more-trigger]");
  }
}

if (!customElements.get("product-card-swatches")) {
  customElements.define("product-card-swatches", ProductCardSwatches);
}
